// ── 기타 매출 탭 콘텐츠 ──────────────────────────────────────────────────────
import React from 'react';
import { FilterBar } from './FilterBar';
import {
  fmtNum, fmtDate,
  tblWrap, thStyle, tdStyle, rowCells,
  btnPrimary, btnSecondary, btnEdit, btnDanger, btnGroup,
} from './styles';

/**
 * 기타 매출 탭 콘텐츠
 * Props:
 *   others
 *   filterStart, setFilterStart, filterEnd, setFilterEnd
 *   loadOthers
 *   setModal, handleDelete
 */
export function TabOthers({
  others,
  filterStart, setFilterStart, filterEnd, setFilterEnd,
  loadOthers,
  setModal, handleDelete,
  auditTableName = 'revenue_others', // 감사 로그 테이블명 (DOT/EXT는 다른 값 전달)
}) {
  // 기간 내 총 합계
  const total = others.reduce((s, r) => s + Number(r.amount || 0), 0);

  return (
    <>
      {/* 필터 바 + 버튼 영역 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 8 }}>
        <FilterBar
          filterStart={filterStart} setFilterStart={setFilterStart}
          filterEnd={filterEnd}     setFilterEnd={setFilterEnd}
          onSearch={loadOthers}
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={btnPrimary}
            onClick={() => setModal({ type: 'other', data: null })}>
            + 등록
          </button>
          <button style={btnSecondary}
            onClick={() => setModal({ type: 'auditlog', tableName: auditTableName, title: '기타' })}>
            이력
          </button>
        </div>
      </div>

      {/* 건수 / 합계 요약 */}
      <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 8 }}>
        총 {others.length}건 / 합계 <strong>{fmtNum(total)}</strong>원
      </div>

      {/* 테이블 */}
      <div style={tblWrap}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['날짜','금액','내용','마케터','비고',''].map((h) => (
                <th key={h} style={thStyle}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {others.length === 0 && (
              <tr>
                <td colSpan={6} style={{ ...tdStyle, borderBottom: 'none', textAlign: 'center', color: 'var(--text-muted)' }}>
                  데이터 없음
                </td>
              </tr>
            )}
            {others.map((r, i) => {
              const c = rowCells(i, others.length); // 마지막 행 밑줄 제거
              return (
              <tr key={r.id}>
                <td style={c.td}>{fmtDate(r.date)}</td>
                <td style={c.amt}>{fmtNum(r.amount)}원</td>
                <td style={c.td}>{r.description}</td>
                <td style={c.td}>{r.user_name || '-'}</td>
                <td style={c.td}>{r.note || '-'}</td>
                <td style={c.btn}>
                  <div style={btnGroup}>
                    <button style={btnEdit}
                      onClick={() => setModal({ type: 'other', data: r })}>수정</button>
                    <button style={btnDanger}
                      onClick={() => handleDelete('others', r.id, '기타 매출')}>삭제</button>
                  </div>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
